import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, CheckCircle, Clock, Shield } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const IdraulicoRomaParioli = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Helmet>
        <title>Idraulico Parioli Roma H24 - Arriviamo in 60 Minuti | Tel 328 768 6356</title>
        <meta name="description" content="Idraulico urgente Parioli Roma H24. Arriviamo entro 60 minuti. Perdite acqua, scarichi intasati. Prezzi chiari. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/idraulico-roma-parioli`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-blue-50 to-indigo-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <div className="bg-blue-600 text-white px-6 py-3 rounded-lg inline-block font-bold mb-4 text-base sm:text-lg md:text-xl animate-pulse break-words max-w-full">
                🚨 Idraulico urgente a Parioli – Arriviamo entro 60 minuti
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Idraulico Parioli Roma H24
              </h1>
              
              <div className="bg-green-100 border-2 border-green-500 rounded-lg p-4 mb-6 inline-block">
                <p className="text-lg sm:text-xl font-bold text-green-800 break-words">✅ Tecnico disponibile ORA</p>
                <p className="text-base sm:text-lg text-green-700 break-words">Intervento immediato a Parioli</p>
              </div>

              <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900 break-words">💰 Prezzi Chiari</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
                  <div className="border-l-4 border-blue-500 pl-4">
                    <p className="font-bold text-base sm:text-lg break-words">Uscita tecnico</p>
                    <p className="text-2xl font-bold text-blue-600">40€</p>
                  </div>
                  <div className="border-l-4 border-orange-500 pl-4">
                    <p className="font-bold text-base sm:text-lg break-words">Entro 1 ora</p>
                    <p className="text-2xl font-bold text-orange-600">60€</p>
                  </div>
                  <div className="border-l-4 border-red-500 pl-4">
                    <p className="font-bold text-base sm:text-lg break-words">Emergenza notte</p>
                    <p className="text-2xl font-bold text-red-600">da 80€</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <a
                  href="tel:3287686356"
                  className="bg-blue-600 hover:bg-blue-700 text-white text-xl py-6 px-8 rounded-lg flex items-center justify-center gap-2 w-full max-w-full break-words"
                >
                  <Phone className="mr-2 h-6 w-6 flex-shrink-0" />
                  <span className="break-words">CHIAMA ORA – ARRIVIAMO SUBITO</span>
                </a>
                <a
                  href="https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20intervento."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white text-xl py-6 px-8 rounded-lg flex items-center justify-center gap-2 w-full max-w-full break-words"
                >
                  <MessageCircle className="mr-2 h-6 w-6 flex-shrink-0" />
                  <span className="break-words">SCRIVI SU WHATSAPP – RISPOSTA IMMEDIATA</span>
                </a>
              </div>

              <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
                <h2 className="text-2xl font-bold mb-4">Problemi Risolti Oggi a Parioli:</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">Perdite acqua urgenti</span>
                  </div>
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">Scarichi intasati</span>
                  </div>
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">Tubi scoppiati</span>
                  </div>
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">Caldaia in blocco</span>
                  </div>
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">WC intasato</span>
                  </div>
                  <div className="flex items-start">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" />
                    <span className="text-lg">Rubinetti che perdono</span>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-6 mb-6">
                <h3 className="text-xl font-bold mb-4">🛡️ Perché Chiamare SOS Casa Roma:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <Clock className="text-blue-600 mr-2" />
                    <span className="font-semibold">Intervento rapido garantito</span>
                  </div>
                  <div className="flex items-center">
                    <Shield className="text-blue-600 mr-2" />
                    <span className="font-semibold">Prezzi chiari</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="text-blue-600 mr-2" />
                    <span className="font-semibold">Tecnici qualificati</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="text-blue-600 mr-2" />
                    <span className="font-semibold">Operiamo anche in ZTL</span>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 mb-4">
                <strong>Zone coperte:</strong> Parioli, Villa Borghese, Salario, Pinciano, Flaminio
              </p>

              <div className="bg-orange-100 border-2 border-orange-500 rounded-lg p-6">
                <p className="text-2xl font-bold text-orange-800 mb-2">☎️ 328 768 6356</p>
                <p className="text-lg text-orange-700">Chiamaci ORA per intervento immediato a Parioli</p>
              </div>
            </div>
          </div>
        </section>
        
        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default IdraulicoRomaParioli;